export default __webpack_public_path__ + "static/media/sysgamingLoader.8b5117a4.svg";